import React from 'react'

import { Contract, User, UserMetadata } from '../../../../common/validations'
import { useAPIGetUserMetadataSuspense } from '../../../api/apiHooks/useAPIGetUserMetadata'
import { useCurrentContract } from '../../../hooks/useCurrentContract/useCurrentContract'
import { useAPIGetUserProfileSuspense } from '../../../api/apiHooks/useAPIGetUserProfile'
import { useAPIGetContractSuspense } from '../../../api/apiHooks/useAPIGetContract'
import { FeedbackAndQuestionNoticeDetails } from '../../../../common/validations/feedbackAndQuestionNotice'
import { DefectNoticeDefectClasses } from '../../../../common/validations/defectNotice'

import { useAPIGetFeedbackNoticeSuspense } from 'api/apiHooks/useAPIGetFeedbackNotice'
import { useCurrentFeedbackNotice } from 'hooks/useCurrentFeedbackNotice/useCurrentFeedbackNotice'
import { useAPIGetDefectClassesSuspense } from 'api/apiHooks/useAPIGetDefectClasses'

interface Data {
  contract: Contract
  user: User
  userMetadata: UserMetadata
  feedbackNotice: FeedbackAndQuestionNoticeDetails
  feedbackClasses: DefectNoticeDefectClasses
}

export const FeedbackViewDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contract } = useAPIGetContractSuspense(currentContractId)
  const { data: feedbackClasses } = useAPIGetDefectClassesSuspense()
  const { data: user } = useAPIGetUserProfileSuspense()

  const { currentFeedbackNoticeUuid } = useCurrentFeedbackNotice()
  const { data: feedbackNotice } = useAPIGetFeedbackNoticeSuspense(
    currentContractId,
    currentFeedbackNoticeUuid
  )

  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  if (!feedbackNotice) {
    throw new Error('NOT_FOUND')
  }

  return children({
    contract,
    user,
    feedbackClasses,
    userMetadata,
    feedbackNotice,
  })
}
